
import { useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

export const useNewsletterSubscription = () => {
  const [isLoading, setIsLoading] = useState(false);

  const subscribe = async (email: string) => {
    if (!email || !email.includes('@')) {
      toast.error('Please enter a valid email address');
      return false;
    }

    setIsLoading(true);
    try {
      const { error } = await supabase
        .from('newsletter_subscriptions')
        .insert({ email: email.toLowerCase().trim() });

      if (error) {
        if (error.code === '23505') { // Unique constraint violation
          toast.error('This email is already subscribed to our newsletter');
        } else {
          console.error('Newsletter subscription error:', error);
          toast.error('Failed to subscribe. Please try again.');
        }
        return false;
      }

      toast.success('Successfully subscribed to our newsletter!');
      return true;
    } catch (error) {
      console.error('Newsletter subscription error:', error);
      toast.error('Failed to subscribe. Please try again.');
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  return { subscribe, isLoading };
};
